import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DetailContainerComponent } from '../../../../common/components/detail-container/detail-container.component';
import { ActivatedRoute } from '@angular/router';
import { EcaBreadcrumbService } from '../../../../eca-breadcrumb/services/eca-breadcrumb.service';
import { OurUserService } from '../../../../users/services/user.service';
import { ErrorHandlingService } from '../../../../services/error-handling.service';
import { CompanyService } from '../../../../company/services/company.service';
import { Subscription } from 'rxjs';
import { IUserInfo } from '../../../../users/models/userInfo.interface';
import { IBreadcrumb } from '../../../../eca-breadcrumb/models/breadcrumb.interface';
import { consts } from '../../../../common/modals/consts';
import { ListDataService } from '../../../../services/list-data.service';
import { IJobTitleInfo } from '../../../../message-models/job-title.interface';
import { HelpModalService } from '../../../../help/services/help-modal.service';
import { HelpConsts } from '../../../../help/models/help-consts';
import { CompanyJobRoleService } from '../../services/company-job-role.service';
import { CompanyJobTitle } from '../../../../message-models/company-job-title.class';
import { ICompanyJobTitle } from '../../../../message-models/company-job-title.interface';
import { MenuItem } from 'primeng/api';
import { ICompanyEngagementHistory } from '../../../../message-models/company-engagement-history.interface';
import { CompanyJobRoleModalService } from '../../services/company-job-role-modal.service';
import { IOperativeTypeInfo } from '../../../../message-models/operative-type.interface';
import { IJobLevelInfo } from '../../../../message-models/job-level.interface';
import { OperativeInfo } from '../../../../domain-model/operative-info.class';
import { OperativesService } from '../../../../operatives/services/operatives.service';
import { EcaConfirmDeleteModalOptions } from '../../../../shared/models/confirm-delete-modal-options.class';
import { EcaConfirmProcessService } from '../../../../shared/services/eca-confirm-process.service';
import { EcaConfirmInfoModalOptions } from '../../../../shared/models/confirm-info-modal-options.class';

@Component({
  selector: 'app-job-role-list',
  templateUrl: './job-role-list.component.html',
  styleUrls: ['./job-role-list.component.scss']
})
export class JobRoleListComponent implements OnInit {
   
  @Input() companyJobTitles: CompanyJobTitle[] = [];

  @Input() operative: OperativeInfo = {} as OperativeInfo;

  @Input() allOperativeTypes: IOperativeTypeInfo[] = [];
  @Input() allJobTitles: IJobTitleInfo[] = []; 
  @Input() allJobLevels: IJobLevelInfo[] = [];

  @Input() addButtonText = 'Add';



  @Output() refreshCompanyJobTitleList: EventEmitter<boolean> = new EventEmitter<boolean>();
 
  public loggedInUser: IUserInfo;
  loggedInUserSubscription: Subscription;
  public companyId: string = consts.emptyGuid;
  //allJobTitles: IJobTitleInfo[] = [];
  filteredJobTitles: IJobTitleInfo[];
  selectedJobTitle: IJobTitleInfo;

  showJobTitleUpdate: boolean;
  loadingJobRoles = false;
  //companyJobTitles: CompanyJobTitle[] = [];
  operatives: OperativeInfo[] = [];
  columns: any[];
  isOnMobile = false;
  rowMenuItems: MenuItem[];
  submitted = false;

  isActive = false;

  @Output() addCompanyJobRoleRequested: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() deleteCompanyJobTitleRequested: EventEmitter<ICompanyJobTitle> = new EventEmitter<ICompanyJobTitle>();
  @Output() refreshCompanyJobTitleSuggested: EventEmitter<boolean> = new EventEmitter<boolean>();
  //@Input() addButtonText = 'Add';
  constructor(private route: ActivatedRoute,
    private ecaBreadcrumbService: EcaBreadcrumbService,
    private userService: OurUserService,
    private errorHandlingService: ErrorHandlingService,
    private confirmProcessService: EcaConfirmProcessService,
    private operativesService: OperativesService,
    private helpService: HelpModalService,
    private companyJobRoleService: CompanyJobRoleService,
    private companyJobRoleModalService: CompanyJobRoleModalService

  )
  {  }




  ngOnInit(): void {

    this.userService.getLoggedInUser().subscribe(user => {
      this.loggedInUser = user;
      this.companyId = this.loggedInUser?.companyId;
       
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    })

   



    this.isOnMobile = window.outerWidth <= 480;

    this.columns = [
      { field: 'name', header: 'Job Title Name', type: 'text' },
      { field: 'updatedBy', header: 'Added by', type: 'text' }

    ];


    this.rowMenuItems = [
      {
        label: 'Remove',
        icon: 'fas fa-trash-alt',
        styleClass: 'eca-menu-item-red',
        command: ($event) => this.deleteCompanyJobTitle($event)
      }
    ]

    this.operativesService.getOperativesInCompany(this.companyId, new Date().toISOString()).subscribe({
      next: operatives => {
        this.operatives = operatives;         
      },
      error: () => {
        this.errorHandlingService.showErrorWarning().subscribe(() => {
        });
      }
    });


  }
   
  openJobRoleHelp() {
    this.helpService.openHelpModal(HelpConsts.CompanySettingJobRoleHelp);
  }
  deleteCompanyJobTitle(companyJobTitle: ICompanyJobTitle) {
    this.isActive = this.isActiveCompanyJobTitle(companyJobTitle);
    console.log(this.isActive);
    if (!this.isActive) {
      this.deleteCompanyJobTitleRequested.emit(companyJobTitle);
    } else {
      this.confirmProcessService.openConfirmProcessModal('<p>Job Roles can only be deleted if they are not in use</p>', 'Remove Company Job Title'
        , new EcaConfirmInfoModalOptions()).subscribe({});
    }
    
  }

  editCompanyJobTitle(companyJobTitle: ICompanyJobTitle, openInEdit: boolean = true) {
    let editCompanyJobTitle = new CompanyJobTitle(companyJobTitle);
    this.companyJobRoleModalService.openCompanyJobTitleEditorModal(
      "Edit Company Job Role for Non electrical " ,
      //this.allJobTitles,
      //this.allJobLevels,
      //this.allOperativeTypes,
      //this.allEmploymentStatuses,
      openInEdit,
      editCompanyJobTitle).subscribe(modalRef => {
        modalRef.content.cancelCompanyJobTitleClicked.subscribe(result => {
          this.companyJobRoleModalService.companyJobTitleEditorModalRef.dynamicDialogRef.close();
          this.refreshCompanyJobTitleSuggested.emit(true);
           
        });
        modalRef.content.saveCompanyJobTitleClicked.subscribe(editCompanyJobTitle => {
          this.loadingJobRoles = true;
          this.companyJobRoleModalService.companyJobTitleEditorModalRef.dynamicDialogRef.close();
          this.companyJobRoleService.CreateOrUpdateCompanyJobTitle(editCompanyJobTitle).subscribe(engagement => {
            this.loadingJobRoles = false;
            this.refreshCompanyJobTitleSuggested.emit(true);
          });
        })
      })
  }
  addCompanyJobTitleEntry() {
    this.addCompanyJobRoleRequested.emit(true);
  }

  isActiveCompanyJobTitle(companyJobTitle: ICompanyJobTitle) {
    var operativeList = this.operatives.find(o => o.currentJobTitleId == companyJobTitle.id);
    if (operativeList != null) {
      return true;
    }
    else return false;
  }
}


